export default __webpack_public_path__ + "static/media/box-4Open.ba09d0da.jpg";